import PropTypes from 'prop-types'

import SalesImpression from 'scripts/utils/dataLayer/Sales/SalesImpression'

import { ProductsCarousel } from 'reactGarden/ProductsCarousel'

import { useDataLayerPush } from 'reactUtils/hooks/use-data-layer-push'

import { Widget } from '../components/Widget'

const Carousel = ({ widget }) => {
  const { type, products, title } = widget

  const callback = () =>
    new SalesImpression(products, type, title).sendImpressionToDataLayer()

  const dataLayerOptions = {
    callback: type ? callback : null
  }

  useDataLayerPush(dataLayerOptions)

  return (
    <Widget title={title} withBackground noContentPadding>
      <ProductsCarousel {...widget} />
    </Widget>
  )
}

Carousel.propTypes = {
  widget: PropTypes.shape({
    type: PropTypes.string,
    products: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        shortName: PropTypes.string.isRequired,
        unit: PropTypes.string.isRequired,
        inWishList: PropTypes.bool.isRequired,
        price: PropTypes.object.isRequired,
        installments: PropTypes.object,
        tag: PropTypes.object,
        offer: PropTypes.object,
        url: PropTypes.string.isRequired
      })
    ).isRequired,
    title: PropTypes.string.isRequired
  })
}

export default Carousel
